export const common = {
  appName: "Sami Abdulsalam",
  welcome: "Welcome",
  continue: "Continue",
  back: "Back",
  next: "Next",
  cancel: "Cancel",
  confirm: "Confirm",
  save: "Save",
  search: "Search",
  loading: "Loading...",
  error: "Error occurred",
  success: "Success",
  retry: "Retry",
  close: "Close",
  edit: "Edit",
  delete: "Delete",
  submit: "Submit",
  login: "Login",
  register: "Register",
  logout: "Logout",
  profile: "Profile",
  settings: "Settings",
  notifications: "Notifications",
  help: "Help",
  contact: "Contact Us",
  privacy: "Privacy",
  terms: "Terms & Conditions"
};